export enum StickyTabsTypes {
    TABS = 'tabs',
    SCROLLER = 'scroller'
}
